import { render, staticRenderFns } from "./StartupMetrics.vue?vue&type=template&id=b2d309d2&scoped=true"
import script from "./StartupMetrics.vue?vue&type=script&lang=js"
export * from "./StartupMetrics.vue?vue&type=script&lang=js"
import style0 from "./StartupMetrics.vue?vue&type=style&index=0&id=b2d309d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d309d2",
  null
  
)

export default component.exports